export const eventsData = [
    {
        id:1,
        image:"./images/events/event1.png",
        title:"Meet with French Institutes",
        description:"Meet the top business, hospitality, engineering schools etc and attend informative sessions on scholarships, studying in France and French language under one roof.",
        date:"3rd March",
        time:"2pm to 5pm",
    },
    {
        id:2,
        image:"./images/events/event1.png",
        title:"Meet with French Institutes",
        description:"Meet the top business, hospitality, engineering schools etc and attend informative sessions on scholarships, studying in France and French language under one roof.",
        date:"3rd March",
        time:"2pm to 5pm",
    },
    

]